import React, { useState } from 'react';
import styles from './AnswerGrid.module.scss';
import AnswerCard from '../AnswerCard/AnswerCard';
import AnswerModal from '../AnswerModal/AnswerModal';

const AnswerGrid = ({ count, showHints, gameId, hasPlaces, hasHints }) => {
  const [modalData, setModalData] = useState(null);

  const handleOpenModal = (index) => {
    setModalData({ index });
  };

  const handleCloseModal = () => {
    setModalData(null);
  };

  return (
    <div className={styles.grid}>
      {Array.from({ length: count }).map((_, i) => (
            <AnswerCard key={i} index={i} showHints={showHints} onClick={() => handleOpenModal(i)} gameId={gameId} />
      ))}
      {modalData && (
        <AnswerModal index={modalData.index} onClose={handleCloseModal} gameId={gameId} hasPlaces={hasPlaces} hasHints={hasHints} />
      )}
    </div>
  );
};

export default AnswerGrid;
